var exports = {
  "k": "xfd349460--42214a--container",
  "_": "xfd349460--42214a--stretch",
};

module.exports = exports;
